/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Magnified_AriaInputs */

const en_image_export_magnified_aria = /** @type {(inputs: Image_Export_Magnified_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magnified Preview`)
};

const fr_image_export_magnified_aria = /** @type {(inputs: Image_Export_Magnified_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previsualisation agrandie`)
};

const de_image_export_magnified_aria = /** @type {(inputs: Image_Export_Magnified_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vergrößerte Vorschau`)
};

const it_image_export_magnified_aria = /** @type {(inputs: Image_Export_Magnified_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anteprima ingrandita`)
};

const ru_image_export_magnified_aria = /** @type {(inputs: Image_Export_Magnified_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Увеличенный предварительный просмотр`)
};

const es_image_export_magnified_aria = /** @type {(inputs: Image_Export_Magnified_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vista previa ampliada`)
};

const zh_cn2_image_export_magnified_aria = /** @type {(inputs: Image_Export_Magnified_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`放大预览`)
};

const ja_image_export_magnified_aria = /** @type {(inputs: Image_Export_Magnified_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`拡大プレビュー`)
};

const hi_image_export_magnified_aria = /** @type {(inputs: Image_Export_Magnified_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बड़ा किया हुआ पूर्वावलोकन`)
};

const pt_pt2_image_export_magnified_aria = /** @type {(inputs: Image_Export_Magnified_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pré-visualização ampliada`)
};

/**
* | output |
* | --- |
* | "Magnified Preview" |
*
* @param {Image_Export_Magnified_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_magnified_aria = /** @type {((inputs?: Image_Export_Magnified_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Magnified_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_magnified_aria(inputs)
	if (locale === "de") return de_image_export_magnified_aria(inputs)
	if (locale === "it") return it_image_export_magnified_aria(inputs)
	if (locale === "ru") return ru_image_export_magnified_aria(inputs)
	if (locale === "es") return es_image_export_magnified_aria(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_magnified_aria(inputs)
	if (locale === "ja") return ja_image_export_magnified_aria(inputs)
	if (locale === "hi") return hi_image_export_magnified_aria(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_magnified_aria(inputs)
	return en_image_export_magnified_aria(inputs)
});